import { Alert, Group, Stack, Text } from "@mantine/core";
import { MantineCopyButton } from "../../../../mantine/components/MantineCopyButton/MantineCopyButton";
import { AlertPresets } from "../../../../mantine/mantinePresets";

interface OAuthApplicationSuccessProps {
  clientId: string;
  clientSecret: string;
  intro: string;
}

function OAuthApplicationSuccess({
  clientId,
  clientSecret,
  intro
}: OAuthApplicationSuccessProps) {
  return (
    <Stack className="OAuthApplicationSuccess">
      <Text>{intro}</Text>

      <Alert
        color={AlertPresets.warning.color}
        icon={AlertPresets.warning.icon}
      >
        Client ID und Client Secret werden einmalig in diesem Dialog angezeigt.
        Bitte sichern Sie Client ID und Client Secret, bevor Sie diesen Dialog
        schließen.
      </Alert>

      <Group justify="space-between" wrap="nowrap">
        <Text>
          <strong>Client ID:</strong>
          <br />
          {clientId}
        </Text>
        <MantineCopyButton copyText="Client ID kopieren" value={clientId} />
      </Group>
      <Group justify="space-between" wrap="nowrap">
        <Text>
          <strong>Client Secret:</strong>
          <br /> {clientSecret}
        </Text>
        <MantineCopyButton
          copyText="Client Secret kopieren"
          value={clientSecret}
        />
      </Group>
    </Stack>
  );
}

export { OAuthApplicationSuccess, OAuthApplicationSuccessProps };
